import AnalyticsClient from './analytics';

// SegmentJS' analytics client is loaded in the global namespace via public/index.html.
const analytics = window.analytics;

export default new AnalyticsClient(analytics);
